import { FullMetadata, getMetadata, listAll, list, getDownloadURL, getBlob, ref, uploadBytes, deleteObject } from 'firebase/storage';
import { storage } from './firebase';
import { userLogging } from './firestore';
import { LOCAL_CONSTANT } from '../page/Const';


const listPageMax = 9

export const getObjectFroFirebase = async (path: string) => {
    const listRef = ref(storage, path);
    const response = await listAll(listRef)
    const pdfList: FullMetadata[] = [];
    for(let i = 0;i < response.items.length; i++){
        const metaData = await getMetadata(response.items[i]);
        pdfList.push(metaData);
    }

    return pdfList;
}

/**
 * 該当ディレクトリ一覧取得
 * @params path
 * @params currentPage
 * @params pageToken
 * @params tokenArray
 */
export const getListPaginateFroFirebase = async (path: string, currentPage: number, pageToken: string, tokenArray: any) => {
    let page = currentPage
    const listRef = ref(storage, path);
    const pdfList: FullMetadata[] = [];
    const tmpToken: any = []
    let nextPageToken: any = []
    if (pageToken === "") {
        const listRef = ref(storage, path);
        const firstPage = await list(listRef, { maxResults: listPageMax });
        for(let i = 0;i < firstPage.items.length; i++){
            const metaData = await getMetadata(firstPage.items[i]);
            pdfList.push(metaData);
        }
        // ページトークン取得
        if (firstPage.nextPageToken && pageToken.length === 0) {
            page = page + 1
            tmpToken.push({
                page: page,
                token: firstPage.nextPageToken
            })
            await getPageToken(listRef, page, firstPage.nextPageToken, tmpToken)
            .then((result: []) => {
                nextPageToken.push(result)
            })
        }
    } else {
        const page = await list(listRef, {
            maxResults: listPageMax,
            pageToken: pageToken,
        });
        for(let i = 0;i < page.items.length; i++){
            const metaData = await getMetadata(page.items[i]);
            pdfList.push(metaData);
        }
    }

    return {
        item: pdfList,
        nextPageToken: tokenArray.length === 0 ? nextPageToken[0] : tokenArray,
    }
}

// firebase storageページトークン取得
const getPageToken = async (listRef: any, page: number, pageToken: string, pageTokenArray: any) => {
    const nextPage = await list(listRef, {
        maxResults: listPageMax,
        pageToken: pageToken,
    });

    if (nextPage.nextPageToken) {
        page = page + 1
        pageTokenArray.push({
            page: page,
            token: nextPage.nextPageToken
        })
        
        await getPageToken(listRef, page, nextPage.nextPageToken, pageTokenArray)
    }

    return pageTokenArray
}

export const getFileData = async (path: string) => {
    const gsReference = ref(storage, path);
        
    return await getDownloadURL(gsReference)
    .then((url) => {
        return url
    })
    .catch((err) => console.log(err));
}

export const getFileMetadata = async (path: string) => {
    const gsReference = ref(storage, path);
        
    return await getMetadata(gsReference)
    .then((meta) => {
        return meta
    })
    .catch((err) => console.log(err));
}

export const uploadFile = async (file: any, path: string) => {
    const storageRef = ref(storage, path);
    
    return await uploadBytes(storageRef, file).then((snapshot) => {
        console.log('Uploaded a file!');
    }).catch((err) => console.log(err));
}

export const deleteUploadFile = async (file: any, path: string) => {
    const desertRef = ref(storage, path);

    return await deleteObject(desertRef)
    .then(() => {
        console.log('File deleted successfully!');
    }).catch((err) => console.log(err));
}

/**
 * オブジェクトからundefinedの値を除外するヘルパー関数
 * JSON.stringify/parseを使用してundefinedを自動的に除外
 * @param obj クリーンアップ対象のオブジェクト
 * @returns undefinedの値が除外されたオブジェクト
 */
const removeUndefinedValues = (obj: any): any => {
    return JSON.parse(JSON.stringify(obj));
}

/**
 * 中間生成物1専用のファイルアップロード関数
 * アップロード結果のログをFirestoreに出力する
 * @param file アップロードするファイル
 * @param path アップロード先のパス
 * @param user ユーザー情報
 * @returns アップロード処理のPromise
 */
export const uploadMiddleProduct1File = async (file: any, path: string, user: any) => {
    const storageRef = ref(storage, path);
    
    return await uploadBytes(storageRef, file).then((snapshot) => {
        console.log('Uploaded a middle product 1 file!');
        
        // 中間生成物1アップロード成功ログ
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.MIDDLE_PRODUCT1_UPLOAD_SUCCESS,
            removeUndefinedValues({
                file_name: file.name,
                file_size_bytes: file.size, // ファイルサイズ（バイト単位）
                upload_path: path,
                snapshot: snapshot
            }),
            user
        );
    }).catch((err) => {
        console.log(err);
        
        // 中間生成物1アップロードエラーログ
        userLogging(
            LOCAL_CONSTANT.FUNCTION_NAME.MIDDLE_PRODUCT1_UPLOAD_ERROR,
            removeUndefinedValues({
                file_name: file.name,
                file_size_bytes: file.size, // ファイルサイズ（バイト単位）
                upload_path: path,
                err: err
            }),
            user
        );
    });
}



/**
 * 既存のファイルを新しい場所にコピーする関数
 * @param sourcePath コピー元のパス
 * @param destinationPath コピー先のパス
 * @returns Promise
 */
export const copyFile = async (sourcePath: string, destinationPath: string) => {
    try {
        // コピー元のファイルの参照を取得
        const sourceRef = ref(storage, sourcePath);
        // コピー元のファイルのメタデータを取得
        const metadata = await getMetadata(sourceRef);
        // コピー元のファイルのバイナリデータを取得
        const blob = await getBlob(sourceRef);
        // コピー先のファイルの参照を取得
        const destinationRef = ref(storage, destinationPath);
        // コピー先にファイルをアップロード
        return await uploadBytes(destinationRef, blob, metadata).then((snapshot) => {
            console.log('File copied successfully!');
            return snapshot;
        });
    } catch (err) {
        console.log('Error copying file:', err);
        throw err;
    }
}
